import { toast } from 'react-toastify';
import { all, call, fork, takeLatest } from 'redux-saga/effects';
import { hasClientCapabilitiesError } from 'api/clientCapabilities';
import { FailToastContainer } from 'components/Toast/ToastContainer';
import { GENERIC_TOAST_ERROR_MESSAGE } from 'config/const';
import { IApiAction } from 'types';

export function* handleFail(action: IApiAction) {
  // A 409 `client_capabilities_required` is already handled by ApiClient, which shows the dedicated
  // "please refresh" prompt. Skip the generic failure toast so the user doesn't see both.
  if (hasClientCapabilitiesError(action.payload)) return;

  if (action.meta?.failToast) {
    yield call(toast, FailToastContainer({ message: action.meta.failToast.message || GENERIC_TOAST_ERROR_MESSAGE }), { toastId: 'unexpected-error' });
  }
}

export function* watchHandleFail() {
  yield takeLatest((action: any) => action.type?.endsWith('FAIL'), handleFail);
}

function* apiSaga() {
  yield all([fork(watchHandleFail)]);
}
export { apiSaga };
